// @ts-strict-ignore
import { IArticlePrepareProcessor } from './i-article-prepare.processor';
import { ArticleVO } from '@article/model/vo/article.vo';
import { SuitableConnectionsSetVO } from '../../model/vo/suitable-connections-set.vo';
import { ConnectionCubeSearchVector } from '@article/components/connections/connection-creation/search/connection-cube-search-vector';
import { ArticlePrepareData } from './insert/article-prepare-data';
import { ArticleAccessoryManager } from '@article/manager/article-accessory.manager';
import { ConnectionCubeSearchHelper } from '@article/components/connections/connection-creation/search/connection-cube-search.helper';
import { Connection } from '@3d-scene/model3d/connection';
import { ConnectArticlePrepareData } from './insert/connect-article-prepare-data';
import { InsertArticlePrepareData } from './insert/insert-article-prepare-data';
import { MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { Injectable } from '@angular/core';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

@Injectable({ providedIn: 'root' })
export class DefaultSingleConnectionPrepareProcessor implements IArticlePrepareProcessor {
  constructor(
    private articleAccessoryManager: ArticleAccessoryManager,
    private connectionCubeSearchHelper: ConnectionCubeSearchHelper
  ) {}

  public process(
    article: ArticleVO,
    givingConnectionSets: SuitableConnectionsSetVO[],
    acceptingCubeVectors: ConnectionCubeSearchVector[],
    checkFreeConnection: boolean
  ): ArticlePrepareData[] {
    return this.processInternal(article, givingConnectionSets, acceptingCubeVectors, checkFreeConnection, false);
  }

  public forceProcess(
    article: ArticleVO,
    givingConnectionSets: SuitableConnectionsSetVO[],
    acceptingCubeVectors: ConnectionCubeSearchVector[],
    checkFreeConnection: boolean = true
  ): ArticlePrepareData[] {
    return this.processInternal(article, givingConnectionSets, acceptingCubeVectors, checkFreeConnection, true);
  }

  private processInternal(
    article: ArticleVO,
    givingConnectionSets: SuitableConnectionsSetVO[],
    acceptingCubeVectors: ConnectionCubeSearchVector[],
    checkFreeConnection: boolean,
    skipAccessoryTest: boolean
  ): ArticlePrepareData[] {
    let articlePrepareDatas: ArticlePrepareData[] = [];
    for (const connectionSet of givingConnectionSets) {
      const cubeVector: ConnectionCubeSearchVector = ConnectionCubeSearchHelper.findCubeVectorById(
        connectionSet.searchVectorId,
        acceptingCubeVectors
      );
      const acceptingConnectionCubes: Connection[] = this.connectionCubeSearchHelper.filterAcceptingConnections(
        cubeVector,
        connectionSet.connectionNames,
        article,
        skipAccessoryTest,
        this.articleAccessoryManager
      );

      const prepareDataByVector: ArticlePrepareData[] = this.createPrepareDataByConnections(article, acceptingConnectionCubes, connectionSet);
      articlePrepareDatas = articlePrepareDatas.concat(prepareDataByVector);
    }
    return articlePrepareDatas;
  }

  private createPrepareDataByConnections(
    article: ArticleVO,
    acceptingConnectionCubes: Connection[],
    connectionSet: SuitableConnectionsSetVO
  ): ArticlePrepareData[] {
    const prepareDatas: ArticlePrepareData[] = [];
    let connectPrepareData: ConnectArticlePrepareData = null;
    for (const acceptingCube of acceptingConnectionCubes) {
      if (ConnectionInfoUtils.isRangeOnLineConnection(acceptingCube.metaElementVO)) {
        const insertPrepareData: InsertArticlePrepareData = new InsertArticlePrepareData(connectionSet.searchVectorId, connectionSet.connectionNames);
        insertPrepareData.acceptingIdentityToInsert = MetaElementUsageIdentityVO.create(
          acceptingCube.articleContainer.articleGUID,
          acceptingCube.connectionName
        );
        insertPrepareData.rotationDelta = this.articleAccessoryManager.getRotationDelta(
          acceptingCube.articleContainer.article.identity,
          article.identity
        );
        prepareDatas.push(insertPrepareData);
      } else {
        if (!connectPrepareData) {
          connectPrepareData = new ConnectArticlePrepareData(connectionSet.searchVectorId, connectionSet.connectionNames);
          connectPrepareData.acceptingConnections = [];
        }
        connectPrepareData.acceptingConnections.push(acceptingCube);
      }
    }
    if (connectPrepareData) {
      prepareDatas.push(connectPrepareData);
    }
    return prepareDatas;
  }
}
